/* eslint-disable complexity */
import { Log } from "~/extensions/utils";
import { store as taikyoStore } from "~/pages/taikyo/store/TaikyoStore";
import { myPageStore } from "~/store/MyPageStore";
import { MsgBox } from "~/components/MsgBox";
import { userType, NyukyoStatus } from "~/extensions/utils/DefineTypes";
import { auth } from "~/core/Auth";
import Loading from 'quasar/src/plugins/loading/Loading.js';
export async function next(to, from, next) {
    const log = Log.create("TaikyoGuard");
    if (!(to.name === "taikyo" || to.name === "taikyo-room-list-next" || to.name === "taikyo-flow-next" || to.name === "taikyo-notification-flow-next" || to.name === "taikyo-applied-list-next")) {
        next();
        return;
    }
    let route;
    try {
        Loading.show();
        const isMultipleKeiyaku = myPageStore.isMultipleKeiyaku;
        const isHojin = auth.userInfo.userType === userType.hojin;
        // 退去メニューに入ってきた場合
        // 単一 or 複数契約の判定は退去ストアのload前に行う
        if (to.name === "taikyo") {
            if (isMultipleKeiyaku) {
                // 複数契約なら部屋選択へ
                route = "taikyo-room-list";
                next({ name: route });
                return;
            }
        }
        const selectBulkTaikyoNo = taikyoStore.taikyoNotificationEntity?.bulkTaikyoNo;
        taikyoStore.clear();
        let status;
        if (isHojin && !taikyoStore.isSave()) {
            if (taikyoStore.selectedRooms.length === 0) {
                taikyoStore.selectedRooms.push(myPageStore.selectedNyukyokeiyaku);
            }
            status = taikyoStore.selectedRooms[0].taikyoStatus;
            taikyoStore.roomSbCheck(taikyoStore.selectedRooms.map(x => x.roomSb));
        }
        else {
            await taikyoStore.load();
            status = taikyoStore.taikyoEntity?.status;
            taikyoStore.roomSbCheck(myPageStore.selectedNyukyokeiyaku.roomSb);
        }
        // 単一契約かつ退去メニューに入ってきた場合
        if (to.name === "taikyo") {
            if (status === NyukyoStatus.Cleared) {
                // 精算完了なら解約精算照会へ
                route = "kaiyaku-seisan";
            }
            else if (isHojin) {
                route = "taikyo-notification-flow-guide";
            }
            else {
                route = "taikyo-flow-guide";
            }
        }
        // 退去部屋選択の次に遷移する場合
        if (to.name === "taikyo-room-list-next") {
            if (isHojin) {
                if (selectBulkTaikyoNo) {
                    taikyoStore.taikyoNotificationEntity.bulkTaikyoNo = selectBulkTaikyoNo;
                    taikyoStore.setPrivacyConsent(true);
                    route = "taikyo-notification-entry";
                }
                else {
                    route = "taikyo-notification-flow-guide";
                }
            }
            else if (status === NyukyoStatus.Cleared) {
                //精算完了なら解約精算照会へ
                route = "kaiyaku-seisan";
            }
            else {
                // 精算完了以外 かつ 個人の場合は退去申請の流れへ
                route = "taikyo-flow-guide";
            }
        }
        // 申請済み一覧の次に遷移する場合
        if (to.name === "taikyo-applied-list-next") {
            if (status === NyukyoStatus.Cleared) {
                // 精算完了なら解約精算照会へ
                route = "kaiyaku-seisan";
            }
            else {
                // 精算完了以外なら退去通知入力確認へ
                taikyoStore.setPrivacyConsent(true);
                route = "taikyo-notification-entry-check";
            }
        }
        // 退去申請の流れの次に遷移する場合
        if (to.name === "taikyo-flow-next") {
            if (status === NyukyoStatus.CurrentlyMovingIn) {
                //退去申請がなければ退去注意事項へ
                route = "taikyo-precaution";
            }
            else if (status === NyukyoStatus.Request) {
                //退去申請中なら確認画面へ
                route = "taikyo-entry-check";
            }
            else {
                //退去申請が承認済みなら解約通知案内へ
                route = "kaiyaku-guide";
            }
        }
        // 退去通知の流れの次に遷移する場合
        if (to.name === "taikyo-notification-flow-next") {
            if (status === NyukyoStatus.CurrentlyMovingIn) {
                // 退去申請なら退去注意事項へ
                route = "taikyo-precaution";
            }
            else {
                // 退去申請以外なら退去通知入力確認へ
                taikyoStore.setPrivacyConsent(true);
                route = "taikyo-notification-entry-check";
            }
        }
    }
    catch (ex) {
        console.error(ex);
        MsgBox.error(ex.message);
        next(false);
        return;
    }
    finally {
        Loading.hide();
    }
    next({ name: route });
}
